import { GenericCell } from '@components/design/migrated/Table';
import { DisplayOptions } from '@components/top-selling-products/products-table-filter/Types';
import { GrowthTypes } from '@data-visualization/performance-segment-chart/Types';
import {
  displayPrimaryCell,
  displayProductsSecondaryCell,
  displaySecColorForPositiveGrowth,
} from '@utils/hook/tableCellConst/TableCellConst';

interface Props {
  headerKey: string;
  cellContent: any;
  currency: string;
  selectedGrowthType?: GrowthTypes;
  selectedDisplayType?: DisplayOptions;
  isHideSecondaryCell?: boolean;
}

const ProductsTableDataCell: React.FC<Props> = ({
  headerKey,
  cellContent,
  currency,
  selectedGrowthType = GrowthTypes.percentage,
  selectedDisplayType = DisplayOptions.data,
  isHideSecondaryCell = false,
}) => {
  return (
    <GenericCell
      primary={displayPrimaryCell(headerKey, cellContent, currency, false)}
      secondary={displayProductsSecondaryCell(
        headerKey,
        cellContent,
        selectedGrowthType,
        currency,
        selectedDisplayType,
        isHideSecondaryCell,
      )}
      secondaryColor={displaySecColorForPositiveGrowth(headerKey, cellContent, selectedGrowthType, false)}
    />
  );
};

export default ProductsTableDataCell;
